/*eslint-disable*/
$('.not-important').on('click', function() {
  $(this).toggleClass('history-active')
  $(this)
    .find('.history-content')
    .slideToggle()
})
/*eslint-enable*/
